import { render } from "./header-links.vue?vue&type=template&id=0d8d1bc9"
import script from "./header-links.vue?vue&type=script&lang=js"
export * from "./header-links.vue?vue&type=script&lang=js"
script.render = render

export default script